<template>
    <div>
        <div class="whiteHeader">
            <div class="container--narrow">
                <div class="whiteHeader__inner">
                    <a class="whiteHeader__back  back-link js-go-back" href="#">{{$t('common.back')}}</a>
                    <h1 class="whiteHeader__title mb-0">{{$t('components.BasketContent.basket')}}</h1>
                </div>
            </div>
        </div>
        <basket-menu></basket-menu>

        <basket-pack :key="pack.id" :pack="pack" v-for="pack in packs"></basket-pack>

        <div class="collection border-bottom ">
            <div class="collection__inner py-4 text-right">
                <span class="text-nowrap note mr-2">{{$t('common.totalPriceWithVat')}}</span>
                <span class="title text-nowrap text-transform-initial">{{ $nf(totalItemDiscountPriceWithVat,  'currency' + currencyCode, 'cs-CZ')}}</span>
            </div>
        </div>

        <!-- slevy -->
        <div class="l-bg pt-6 pb-8">
            <h2 class="h1 text-center mb-4">{{$t('common.yourDiscounts')}}</h2>

                <div class="container--narrow text-1">
                    <div class="container-white">
                        <basket-voucher-row :basket="basket"></basket-voucher-row>
                        <basket-credit-row v-if="showCreditRow" :basket="basket"></basket-credit-row>
                        <basket-discount-row v-if="showSpecialDiscountRow" :discount="specialDiscount"></basket-discount-row>
                    </div>
                </div>



            <div class="container text-center text-md-right mt-6 mb-4 mb-md-8 mt-md-8">
                <span class="note mr-2">{{$t('common.totalPriceWithVat')}}</span>
                <span class="title text-nowrap text-transform-initial">{{ $nf(totalDiscountPriceWithVat, 'currency' + currencyCode, 'cs-CZ')}}</span>
            </div>

            <div class="container ">
                <div class="row no-gutters">
                    <div class="col-md-6 order-md-2 text-center text-md-left  mb-8 mb-md-0">
                        <basket-free-delivery v-if="basket.showFreeDeliveryBar" :basket="basket"></basket-free-delivery>
                    </div>
                    <div class="col-md-6 text-center text-md-right order-md-3">
                        <a href="#" @click.prevent="editTransportationAndPayment" class="btn btn--cta btn--big">
                            {{$t('components.BasketContent.transportAndPayment')}}
                        </a>
                    </div>

                </div>
            </div>
        </div> <!-- /l-gb -->
    </div>
</template>

<script>
    import BasketCreditRow from "./BasketCreditRow";
    import BasketMenu from "./BasketMenu";
    import BasketPack from "./BasketPack";
    import BasketVoucherRow from "./BasketVoucherRow";
    import BasketDiscountRow from "./BasketDiscountRow";
    import BasketFreeDelivery from "./BasketFreeDelivery";

    export default {
        components: {BasketFreeDelivery, BasketCreditRow, BasketMenu, BasketPack, BasketVoucherRow, BasketDiscountRow},
        computed: {
            basket: function () {
                return this.$store.getters.basket;
            },
            packs: function () {
                return this.basket.itemPacks;
            },
            totalItemPriceWithVat: function () {
                return this.basket.totalPrice.priceWithVat;
            },
            totalItemDiscountPriceWithVat: function () {
                return this.basket.totalPackagesDiscountedPrice.priceWithVat;
            },
            totalDiscountPriceWithVat: function () {
                let price = this.basket.totalDiscountPrice.priceWithVat;
                //DOTO - Ales: temporary solution, after basket discounts implementation this feature will be implemented on backend
                let user = this.$store.getters.user;

                if (user && user.creditsDiscount) {
                    price -= user.creditsDiscount;
                }

                if (price < 0){
                    price = 0;
                }

                return price;
            },
            currency: function () {
                return this.basket.totalPrice.currency.htmlString;
            },
            currencyCode: function () {
                return this.basket.totalPrice.currency.code;
            },
            specialDiscount: function () {
                var specialDiscouns = this.basket.discounts.filter(function (item) {
                    return item.uid === 'VIP_DISCOUNT'
                });
                if (specialDiscouns.length > 0) {
                    return specialDiscouns[0];
                } else {
                    return null;
                }
            },
            getUser: function () {
                return this.$store.getters.user;
            },
            showCreditRow: function () {
                var user = this.getUser;
                if (typeof user != 'undefined' && user.credits > 0) {
                    return true;
                }
                return false;
            },
            showSpecialDiscountRow: function () {
                return this.specialDiscount !== null;
            }
        },
        methods: {
            editTransportationAndPayment: function () {
                this.$store.dispatch("editTransportationAndPayment", {});
            },
            backToStore: function () {
                this.$store.dispatch("backToStore", {});
            }
        }
    };
</script>
